// extracted by mini-css-extract-plugin
module.exports = {"header":"Listing_header__JsKmV","body":"Listing_body__3d5KY"};